import { useHead } from '@vueuse/head';

const images = [
  {
    path: '/tv_filter.png',
    type: 'image/png',
  },
  {
    path: '/tv_glass.png',
    type: 'image/png',
  },
  {
    path: '/tv_frame.png',
    type: 'image/png',
  },
  {
    path: '/blur.png',
    type: 'image/png',
  },
  {
    path: '/tv_button.webp',
    type: 'image/webp',
  },
];

export function useImagePreloader() {
  useHead({
    link: images.map((image) => ({
      rel: 'preload',
      href: image.path,
      as: 'image',
      type: image.type,
    })),
  });
}
